import { render, staticRenderFns } from "./SelectSchool.vue?vue&type=template&id=4a822d01&"
import script from "./SelectSchool.vue?vue&type=script&lang=ts&"
export * from "./SelectSchool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports